import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import FolderTable from "../components/FolderTable";
import Pagination from "../components/Pagination";
import { useLoading } from "../context/LoadingContext";
import useApi from "../utils/useApi";
import Toaster, { ToastContainerComponent } from "../components/Toaster"; // ✅ Toaster for notifications
import InfoModal from "../components/InfoModal";
import { useAuth } from "../context/AuthContext";

const FavoritesFolders = () => {
  const { callApi } = useApi();
  const { setLoading } = useLoading();
  const [folders, setFolders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const foldersPerPage = parseInt(process.env.REACT_APP_PER_PAGE) || 50; // Default: 5 items per page
  const [totalFolders, settotalFolders] = useState(0);
  // 📌 User Selection States
 
  const navigate = useNavigate();
  const [selectedFolderDetails, setSelectedFolderDetails] = useState(null);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const { user } = useAuth();
  
  // ✅ Fetch folders from API
  const fetchFavFolders = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        length: foldersPerPage,
      };
      const apiPath = user?.user_role?.toLowerCase() === "client" ? "client" : "admin/clients";
      const response = await callApi({ endpoint: `/${apiPath}/get-favourite-directories`, params });

      if (response?.success) {
        setFolders(response.data?.directories || []);
        settotalFolders(response.data.total || 0);
      } else {
        Toaster.error("Failed to load folders."); // ✅ Using Toaster for errors
      }
    } catch (error) {
      console.error("Error fetching folders:", error);
      Toaster.error("Error fetching folders. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFavFolders();
  }, [currentPage]);



  const detailsFolder = (entity_id) => {
    navigate(`/folder-details/${entity_id}`);
  };

  const getSelectedFolderDetails = async(entity_id) => {
    setLoading(true);
    try {
      //const response = await callApi({ endpoint: `/admin/directories/get-directory-info/${entity_id}` });
      const apiPath = user?.user_role?.toLowerCase() === "client" ? "client" : "admin/directories";
      const response = await callApi({
        endpoint: `/${apiPath}/get-directory-info/${entity_id}`,
      });
      if (response?.success) {
        setSelectedFolderDetails(response?.data)
        setIsInfoModalOpen(true);
      } else {
        Toaster.error("Failed to fetch folder details."); // ✅ Using Toaster for errors
      }
    } catch (error) {
      console.error("Failed to fetch folder details:", error);
      Toaster.error("Failed to fetch folder details. Please try again.");
    } finally {
      setLoading(false);
    }
  };



  const folderDetailsModal = (entity_id) => {
    getSelectedFolderDetails(entity_id);
    
  };

  const onRename = async(newSubmitFolderName,fDetails) => {
    if (!newSubmitFolderName.trim()) {
      Toaster.error("Folder name is required."); // ✅ Toaster instead of alert
      return;
    }

    setLoading(true);
    try {
      const apiPath = user?.user_role?.toLowerCase() === "client" ? "client" : "admin/directories";
      const response = await callApi({
        endpoint: `/${apiPath}/rename-folder`,
        method: "POST",
        data: {
          entity_name: newSubmitFolderName,
          entity_id: fDetails.entity_id
        },
      });

      if (response?.success) {

        Toaster.success("Folder renamed successfully!");

        fetchFavFolders(); // Reload folders
        setIsInfoModalOpen(false);
      } else {
        Toaster.error(response?.data?.message || "Failed to rename folder.");
      }
    } catch (error) {
      console.error("Error rename folder:", error);
      Toaster.error("Error rename folder. Please try again.");
    } finally {
      setLoading(false);
    }
  }


   
  const addFolderFavorite = async(entity_id,is_favorite) =>{
    
  }
  const removeFavorite = async(entity_id,is_favorite) =>{
    setLoading(true);
    try {
      const apiPath = user?.user_role?.toLowerCase() === "client" ? "client" : "admin/clients";
      const response = await callApi({
        endpoint: `/${apiPath}/remove-user-favourite-directory`,
        method: "POST",
        data: {
          entity_id: entity_id
        },
      });

      if (response?.success) {

        Toaster.success("Folder removed from favorites!");

        fetchFavFolders(); 
      } else {
        Toaster.error(response?.data?.message || "Failed to remove favorite folder.");
      }
    } catch (error) {
      console.error("Error to remove favorite folder:", error);
      Toaster.error("Error to remove favorite folder. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const deleteFolder = null;

  return (
    <MainLayout>
      <ToastContainerComponent /> {/* ✅ Toaster Container for notifications */}
      <div className="inner_full_right_part">
        <div className="row">
          <div className="col-md-12">
            <div className="global_cardbox">
              <div className="global_card_header">
                <div className="row">
                  <div className="col-md-3">
                    <div className="global_head_tag">
                      <span><i className="fa-solid fa-folder-open"></i></span> Favorite Folders
                    </div>
                  </div>
                </div>
              </div>

              <div className="shared_folder_holder">
                <FolderTable
                  folders={folders}
                  detailsFolder={detailsFolder}
                  folderDetailsModal={folderDetailsModal}
                  addFolderFavorite = {removeFavorite}
                  deleteFolder = {deleteFolder}
                />
                <Pagination
                  currentPage={currentPage}
                  totalPages={Math.ceil(totalFolders / foldersPerPage)}
                  setCurrentPage={setCurrentPage}
                />
              </div>
            </div>
          </div>
        </div>
      </div>




      {/* ✅ Folder Details Modal */}
      {isInfoModalOpen && (
        <InfoModal
          isOpen={isInfoModalOpen}
          onClose={() => setIsInfoModalOpen(false)}
          folderDetails={selectedFolderDetails}
          onRename = {onRename}
        />
      )}


    </MainLayout>
  );
};

export default FavoritesFolders;
